module.exports = __webpack_public_path__ + "assets/img/888.a186175c.png";